import { render, staticRenderFns } from "./goodsColumn.vue?vue&type=template&id=5558429a&scoped=true&"
import script from "./goodsColumn.vue?vue&type=script&lang=js&"
export * from "./goodsColumn.vue?vue&type=script&lang=js&"
import style0 from "./goodsColumn.vue?vue&type=style&index=0&id=5558429a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5558429a",
  null
  
)

export default component.exports